/**
 * Created by shobhitjain on 27/12/19.
 */

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import style from './index.scss';
import { DataModelWithDownload } from '../../../../../components/HoverableTD';
import {
  convertToFormattedMoney,
  putHyphenIfEmpty
} from '../../../../../services/util';
import { ITALIC_ROWS } from '../../../investigationDetail/CustomerActivity/customerActivityUtil';
import {
  MAX_FRACTION_DIGITS,
  MIN_FRACTION_DIGITS
} from '../../../../../util/GlobalConstant';

/**
 * getStatusStyle function for returning risk style
 * @param riskRating
 * @returns {{style: string, label: string}|{style: *, label: string}}
 */
const getStatusStyle = (riskRating = '-') => {
  if (riskRating.toLowerCase().indexOf('low') !== -1) {
    return { style: style.status_low, label: 'Low' };
  } else if (riskRating.toLowerCase().indexOf('medium') !== -1) {
    return { style: style.status_medium, label: 'Medium' };
  } else if (riskRating.toLowerCase().indexOf('high') !== -1) {
    return { style: style.status_high, label: 'High' };
  }
  return { style: '', label: '-' };
};

/**
 * getTitleText
 * @param tableRow
 * @param row
 * @returns {string|*}
 */
const getTitleText = (tableRow, row) => {
  if (tableRow['maskApplied'] !== undefined) {
    if (tableRow['maskApplied']) {
      return 'Customer is a Staff';
    }
    return tableRow[row.key];
  } else {
    return tableRow[row.key];
  }
};
/**
 * TableRow returns TD on type of row param given
 * @param tableRowData
 * @param keys
 * @param isClickableRow
 * @param excludedObjectForStyle
 * @param associatedObject
 * @param inOut
 * @param nanHandler
 * @returns {*}
 * @constructor
 */
const TableRow = ({
  tableRowData,
  keys,
  isClickableRow,
  excludedObjectForStyle,
  associatedObject,
  inOut,
  nanHandler = 'empty'
}) => {
  return (
    <tr>
      {keys
        .filter((currentKey) => currentKey !== null)
        .map((row) => {
          if (row.key === 'account_id') {
            if (tableRowData['isAlertedAccount']) {
              return (
                <td
                  title={getTitleText(tableRowData, row)}
                  key={row.key}
                  className={style.status_high}>
                  {tableRowData[row.key]}
                </td>
              );
            }
          }

          if (row.key === 'riskRating') {
            const riskRating = getStatusStyle(tableRowData['riskRating']);
            return (
              <td
                title={getTitleText(tableRowData, row)}
                key={row.key}
                className={riskRating.style}>
                {riskRating.label}
              </td>
            );
          }

          if (isClickableRow) {
            const isItalicNeeded =
              ITALIC_ROWS.indexOf(tableRowData['transactionName']) !== -1;
            if (row.key.indexOf('totalAmount_') !== -1) {
              return (
                <DataModelWithDownload
                  rowKey={row.key}
                  rowData={row}
                  isItalicNeeded={isItalicNeeded}
                  associatedObject={associatedObject}
                  row={tableRowData}
                  firstDataPoint={tableRowData[row.key]}
                  inOut={inOut}
                />
              );
            }

            let formattedTitle = tableRowData[row.key];
            let formattedValue = tableRowData[row.key];

            if (row.formatNumeric) {
              formattedTitle = convertToFormattedMoney(
                tableRowData[row.key],
                MAX_FRACTION_DIGITS
              );
            }
            if (
              row.key.indexOf('count_') === -1 &&
              row.key.indexOf('transactionName') === -1
            ) {
              formattedValue = convertToFormattedMoney(
                tableRowData[row.key],
                MIN_FRACTION_DIGITS
              );
            }

            return (
              <td
                className={classnames(
                  isItalicNeeded ? style.makeItalicAndBold : ''
                )}
                title={formattedTitle}
                key={row.key}>
                {putHyphenIfEmpty(formattedValue)}
              </td>
            );
          }

          if (row.formatNumeric) {
            if (row.isMoney) {
              return (
                <td
                  title={convertToFormattedMoney(
                    tableRowData[row.key],
                    MAX_FRACTION_DIGITS,
                    nanHandler
                  )}
                  key={row.key}>
                  {convertToFormattedMoney(
                    tableRowData[row.key],
                    2,
                    nanHandler
                  )}
                </td>
              );
            }
          }

          return (
            <td title={getTitleText(tableRowData, row)} key={row.key}>
              {putHyphenIfEmpty(tableRowData[row.key])}
            </td>
          );
        })}
    </tr>
  );
};

/**
 * Proptypes
 * @type {{keys: shim, tableRowData: shim, excludedObjectForStyle: shim, isClickableRow: shim, associatedObject: shim}}
 */
TableRow.propTypes = {
  tableRowData: PropTypes.array.isRequired,
  keys: PropTypes.array.isRequired,
  isClickableRow: PropTypes.bool,
  excludedObjectForStyle: PropTypes.object,
  associatedObject: PropTypes.object
};
/**
 * Default props
 * @type {{excludedObjectForStyle: {}, isClickableRow: boolean, associatedObject: {}}}
 */
TableRow.defautProps = {
  isClickableRow: false,
  excludedObjectForStyle: {},
  associatedObject: {}
};

export default TableRow;
